export default __webpack_public_path__ + "static/media/icon-persona-cuote.3d7ca70f.svg";